var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"Admin_Accessor__info"},[_vm._m(0),_c('span',{staticClass:"accessor"},[_vm._v(" "+_vm._s(_vm.count)+" 명 ")])])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('span',{staticClass:"count"},[_c('span',{staticClass:"line"},[_vm._v("|")]),_c('span',{},[_vm._v("10분 전 접속자 수")])])
}]

export { render, staticRenderFns }